export const imageUrlHelper = (img: string) => {
    if(!img || img?.length < 1) return ''
    let str = img
    if(str[0] === '~'){
        str = str?.slice(1)
    }
    if(str?.includes('https')) return str
    return str?.replace('http', 'https')

}